import {
  FILESYSTEM_STRUCTURE_ENDPOINT,
  FILESYSTEM_FOLDERS_ENDPOINT,
  FILESYSTEM_FILES_ENDPOINT,
  FILESYSTEM_ITEMS_ENDPOINT,
  FILESYSTEM_ITEM_BY_ID_ENDPOINT,
  FILESYSTEM_ITEM_RENAME_ENDPOINT,
  FILESYSTEM_ITEM_MOVE_ENDPOINT,
  FILESYSTEM_FOLDER_BY_ID_ENDPOINT,
  FILESYSTEM_SEARCH_ENDPOINT,
} from "./endpoints";
import { getAPI, postAPI, putAPI, deleteAPI } from "./apiMethods";
import api from "./api";

export async function getFileStructure() {
  try {
    const response = await api.get(FILESYSTEM_STRUCTURE_ENDPOINT);
    if (!response.data.success) {
      throw new Error(response.data.message || "Failed to get file structure");
    }
    return response.data.data;
  } catch (error) {
    console.error("getFileStructure error:", error);
    throw error.response?.data || error;
  }
}

export async function createFolder(name, parentId = null) {
  try {
    const response = await api.post(FILESYSTEM_FOLDERS_ENDPOINT, {
      name,
      parentId,
    });
    if (!response.data.success) {
      throw response.data;
    }
    return response.data.data;
  } catch (error) {
    console.error("createFolder error:", error);
    throw error.response?.data || error;
  }
}

export async function uploadFile(file, parentId = null) {
  const formData = new FormData();
  formData.append("file", file);
  if (parentId) formData.append("parentId", parentId);

  try {
    const token = localStorage.getItem("jwtToken");
    const response = await fetch(
      `${
        process.env.REACT_APP_API_BASE_URL || "http://localhost:5000/api"
      }${FILESYSTEM_FILES_ENDPOINT}`,
      {
        method: "POST",
        headers: {
          Authorization: token ? `Bearer ${token}` : undefined,
        },
        body: formData,
      }
    );

    const result = await response.json();
    if (!result.success) {
      throw new Error(result.message || "Upload failed");
    }
    return result.data;
  } catch (error) {
    console.error("uploadFile error:", error);
    throw error;
  }
}

export async function deleteItem(id) {
  try {
    const response = await api.delete(FILESYSTEM_ITEM_BY_ID_ENDPOINT(id));
    if (!response.data.success) {
      throw new Error(response.data.message || "Failed to delete item");
    }
    return response.data.data;
  } catch (error) {
    console.error("deleteItem error:", error);
    throw error.response?.data || error;
  }
}

export async function renameItem(id, newName) {
  try {
    const response = await api.put(FILESYSTEM_ITEM_RENAME_ENDPOINT(id), {
      newName,
    });
    if (!response.data.success) {
      throw new Error(response.data.message || "Failed to rename item");
    }
    return response.data.data;
  } catch (error) {
    console.error("renameItem error:", error);
    throw error.response?.data || error;
  }
}

export async function moveItem(id, newParentId) {
  try {
    const response = await api.put(FILESYSTEM_ITEM_MOVE_ENDPOINT(id), {
      newParentId,
    });
    if (!response.data.success) {
      throw new Error(response.data.message || "Failed to move item");
    }
    return response.data.data;
  } catch (error) {
    console.error("moveItem error:", error);
    throw error.response?.data || error;
  }
}

export async function getFolderContents(folderId) {
  try {
    const response = await api.get(FILESYSTEM_FOLDER_BY_ID_ENDPOINT(folderId));
    if (!response.data.success) {
      throw new Error(response.data.message || "Failed to get folder contents");
    }
    return response.data.data;
  } catch (error) {
    console.error("getFolderContents error:", error);
    throw error.response?.data || error;
  }
}

export async function searchItems(query) {
  try {
    const response = await api.get(FILESYSTEM_SEARCH_ENDPOINT(query));
    if (!response.data.success) {
      throw new Error(response.data.message || "Failed to search items");
    }
    return response.data.data;
  } catch (error) {
    console.error("searchItems error:", error);
    throw error.response?.data || error;
  }
}
